import * as Yup from "yup";
import { editOrderStatusService } from "../../services/ordersServices.js";
import Alert from "../../utils/Alert.js";

export const initialValues = {
    status: "",
    transfer_price: "",
    tax: "",
    discount_code: "",
    isPaid: false
}

export const initialTouched = {
    status: true,
    transfer_price: true,
    tax: true,
    discount_code: true
}

export const onSubmit = async (values, actions, editingOrder, setData, navigate) => {
    // "isPaid" is an additional field to recognize the payment status of order.
    const { isPaid, ...data } = values;
    // const { transfer_price, tax, ...paidData } = data;
    const finalValues = data
    try {
        const response = await editOrderStatusService(editingOrder.code, finalValues);
        if (response.status === 200) {
            setData(prevOrders => prevOrders.map(o => {
                if (o.code === editingOrder.code) {
                    return response.data;
                }
                return o;
            }))
            Alert("انجام عملیات", "وضعیت سفارش با موفقیت تغییر یافت", "success");
            return navigate(-1);
        }
    } catch (error) {

    }
}

export const validationSchema = Yup.object().shape({
    status: Yup.string().required("لطفاً یک وضعیت را انتخاب کنید"),
    transfer_price: Yup.number().when("isPaid", {
        is: false,
        then: (schema) => schema.required("لطفاً هزینه‌ی ارسال را مشخص کنید")
            .typeError("لطفاً فقط عدد وارد کنید")
            .min(0, "هزینه‌ی ارسال نمی‌تواند منفی باشد")
    }),
    tax: Yup.number().when("isPaid", {
        is: false,
        then: (schema) => schema.required("لطفا مالیات بر ارزش افزوده را مشخص کنید.")
        .typeError("لطفا فقط عدد وارد کنید")
        .min(0, "مالیات بر ارزش افروده نمی‌تواند منفی باشد.")
    }),
    discount_code: Yup.string().when("isPaid", {
        is: false,
        then: (schema) => schema.required("لطفا کد تخفیف را مشخص کنید.")
    })
})
